import { eEstadoMaestro } from "../common/enumModel";
import { ITipoAccidenteModel } from "../interfaces/tipo-accidente/ITipoAccidenteModel";

export class TipoAccidenteModel implements ITipoAccidenteModel {
    
    idTipoAccidente : number;
    nombre : string;
    idEstado: eEstadoMaestro;
    estado: string;
    
    constructor(){
        this.idTipoAccidente = 0;
        this.nombre = '';
        this.idEstado = eEstadoMaestro.ACTIVO;
        this.estado = '';
    }
}